import { Component, inject, OnInit } from '@angular/core';
import { ChipsModule } from 'primeng/chips';
import { DividerModule } from 'primeng/divider';
import { EditorModule } from 'primeng/editor';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { FormFooterComponent } from '../../molecules/form-footer/form-footer.component';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { PrimeTemplate } from 'primeng/api';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { BaseFormComponent } from '../../molecules/base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtilityService } from '../../../utility/app.utility';
import { RoutingService } from '../../../services/routing.service';
import { PermissionService } from '../../../services/permission.service';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { NotificationStore } from '../../../stores/notification/notification.state';
import { Notification } from '../../../models/notification';
import { InputSwitchModule } from 'primeng/inputswitch';

@Component({
  selector: 'app-notification-form',
  standalone: true,
  imports: [
    ChipsModule,
    DividerModule,
    EditorModule,
    FormFieldWrapperComponent,
    FormFooterComponent,
    InputTextModule,
    NgIf,
    PaginatorModule,
    PrimeTemplate,
    ReactiveFormsModule,
    InputSwitchModule,
  ],
  templateUrl: './notification-form.component.html',
  styleUrl: './notification-form.component.scss',
})
export class NotificationFormComponent
  extends BaseFormComponent<Notification>
  implements OnInit
{
  override formInitialized = false;
  readonly store = inject(NotificationStore);

  constructor(
    router: Router,
    route: ActivatedRoute,
    appUtilityService: AppUtilityService,
    routingService: RoutingService,
    permissionService: PermissionService,
    confirmationDialogService: ConfirmationDialogService,
    private fb: FormBuilder
  ) {
    super(
      router,
      route,
      appUtilityService,
      routingService,
      permissionService,
      confirmationDialogService
    );
  }

  /**
   * Initializes the component upon creation. Calls the parent class's ngOnInit
   * method and performs additional setup tasks specific to this component,
   * such as initializing the form.
   *
   * @return {void} No return value.
   */
  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeForm();
  }

  /**
   * Initializes the form with values based on the currently selected item in the store.
   * Sets up reactive form controls with default or item-specific values.
   *
   * @return {void} Does not return a value.
   */
  initializeForm(): void {
    this.itemToEdit = this.store.selectedItem();
    this.form = this.fb.group({
      title: [this.itemToEdit?.title || '', Validators.required],
      textShort: [this.itemToEdit?.textShort || ''],
      text: [this.itemToEdit?.text || '', Validators.required],
      keywords: [this.itemToEdit?.keywords || ''],
      locked: [this.itemToEdit?.locked || true],
    });
    this.formInitialized = true;
  }

  /**
   * Handles the submission logic of a form or user action. This method calls the submit function
   * to execute the desired behavior upon submitting.
   *
   * @return {void} This method does not return a value.
   */
  onSubmit(): void {
    this.submit();
  }
}
